import { render } from "./UnderConstructionPage.vue?vue&type=template&id=0d3b4d45&ts=true"
import script from "./UnderConstructionPage.vue?vue&type=script&lang=ts"
export * from "./UnderConstructionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__